export default __webpack_public_path__ + "static/media/remove.d6b11406.svg";